/** Format a sequential interview session number as a human-readable Interview ID */
export function formatInterviewId(sessionNumber: number | null | undefined): string {
  if (!sessionNumber) return '';
  return `INT-${String(sessionNumber).padStart(5, '0')}`;
}
